function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { themify, tint } from '../styles/mixins';
import { Label } from './Input';
const StyledTextarea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextarea",
  componentId: "sc-2hw0li-0"
})(["appearance:none;background:", ";border:1px solid ", ";border-radius:3px;color:", ";padding:1em;min-height:", ";font-size:", ";width:", ";resize:", ";&::-webkit-input-placeholder{color:", ";}&::-moz-placeholder{color:", ";}&:-moz-placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&:focus{outline:none;border-color:", ";}"], x => x.$bgColor, x => x.$borderColor, x => x.$color, x => x.$minHeight, x => x.theme.type.scale[x.$fontSize], x => x.$width, x => x.$resize, x => rgba(tint(0.75, x.$color), 0.5), x => rgba(tint(0.75, x.$color), 0.5), x => rgba(tint(0.75, x.$color), 0.5), x => rgba(tint(0.75, x.$color), 0.5), x => tint(0.9, x.theme.colors.green));
export const Error = styled.span.withConfig({
  displayName: "Textarea__Error",
  componentId: "sc-2hw0li-1"
})(["float:right;color:", ";font-size:", ";"], x => x.theme.colors.red, x => x.theme.type.scale[6]);
export const Textarea = (_ref) => {
  let {
    bgColor = 'white',
    borderColor = 'gray',
    className,
    color = 'grayBlack',
    defaultValue,
    fontSize = 5,
    label,
    labelColor = 'grayDark',
    labelSize = 6,
    minHeight = '5em',
    id,
    resize = 'vertical',
    width = '100%',
    touched,
    error
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["bgColor", "borderColor", "className", "color", "defaultValue", "fontSize", "label", "labelColor", "labelSize", "minHeight", "id", "resize", "width", "touched", "error"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Label, {
    $fontSize: fontSize,
    $labelColor: themify(labelColor),
    $labelSize: labelSize,
    htmlFor: id
  }, label, touched && error && /*#__PURE__*/React.createElement(Error, null, error)), /*#__PURE__*/React.createElement(StyledTextarea, _extends({
    key: `textarea-${id}`,
    $bgColor: themify(bgColor),
    $borderColor: themify(touched && error ? 'red' : borderColor),
    $color: themify(color),
    $fontSize: fontSize,
    $minHeight: minHeight,
    $resize: resize,
    $width: width,
    className: className,
    defaultValue: defaultValue,
    id: id
  }, rest)));
};